import { useState } from 'react';
import { faqs } from '../data';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="section faq" id="faq">
      <div className="container">
        <div className="faq-head" data-reveal>
          <h2 className="display-2">
            Frequently asked <em>questions.</em>
          </h2>
          <p className="section-lede">
            Still wondering about something? Ask us directly — we’ll give you a straight answer.
          </p>
        </div>

        <div className="accordion faq-accordion" data-reveal>
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            const panelId = `faq-panel-${index}`;
            const buttonId = `faq-button-${index}`;

            return (
              <div className={isOpen ? 'faq-item is-open' : 'faq-item'} key={item.question}>
                <h3 className="faq-question">
                  <button
                    type="button"
                    id={buttonId}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    <span>{item.question}</span>
                    <span className="faq-icon" aria-hidden="true" />
                  </button>
                </h3>
                <div className="faq-panel" id={panelId} role="region" aria-labelledby={buttonId}>
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
